import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

export default function CashoutError({ onClose, titleKey, descriptionKey }) {
  const { t } = useTranslation(null, { useSuspense: false });

  return (
    <div
      className="phoenix-simple-dialog-view modal member-diamonds-cash-confirm in show"
      aria-hidden="false"
    >
      <div className="modal-backdrop fade in" />
      <div className="modal-dialog">
        <div className="modal-content modal-content-sw">
          <div className="cashout-failed-result text-center">
            <div className="modal-header">
              <a
                className="close phoenix-icon phoenix-icon-cross"
                onClick={onClose}
              />
              <h4 className="modal-title text-center">
                {t(titleKey)}
              </h4>
            </div>

            <div className="modal-body">
              <p className="text-muted mb-4">
                {t(descriptionKey)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

CashoutError.propTypes = {
  onClose: PropTypes.func.isRequired,
  titleKey: PropTypes.string,
  descriptionKey: PropTypes.string,
};

CashoutError.defaultProps = {
  titleKey: 'cashout_cash_out_error',
  descriptionKey: 'cashout_cash_out_error_description',
};
